import cafe24Api from './index';

export default {
  cafe24OpenApi() {
    return {
      code: () => cafe24Api.cafe24Request.get(`/commerce/cafe24/code`),
      cancel: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/cancellation/${data.brandId}/${data.claimCode}`, { params: data.sendData }),
        request: (data) => cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/cancellationrequests/${data.brandId}`, { data: data.sendData })
      },
      customers: {
        member: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/customers/${data.brandId}`, { params: data.sendData }),
        coupon: (data) =>
          cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/customers/${data.brandId}/${data.memberId}/coupons`, { params: data.sendData })
      },
      exchange: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/exchange/${data.brandId}/${data.claimCode}`, { params: data.sendData }),
        request: (data) =>
          cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/exchangerequests/${data.brandId}/${data.orderId}`, { data: data.sendData })
      },
      orders: {
        list: {
          orderList: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/orders/${data.brandId}`, { params: data.sendData }),
          orderId: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}`, { params: data.sendData }),
          buyer: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/buyer`, { params: data.sendData }),
          memos: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/memos`, { params: data.sendData }),
          shipments: (data) =>
            cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/shipments`, { params: data.sendData })
        },
        request: {
          cancellation: (data) =>
            cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/cancellation`, { data: data.sendData }),
          exchange: (data) =>
            cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/exchange`, { data: data.sendData }),
          memos: (data) => cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/memos`, { data: data.sendData }),
          return: (data) => cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/return`, { data: data.sendData })
        },
        change: {
          receivers: (data) =>
            cafe24Api.cafe24Request.put(`/commerce/cafe24/v1/orders/${data.brandId}/${data.orderId}/receivers`, { data: data.sendData })
        }
      },
      points: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/points/${data.brandId}`, { params: data.sendData })
      },
      produets: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/products/${data.brandId}`, { params: data.sendData }),
        detail: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/products/${data.brandId}/${data.productNo}`, { params: data.sendData })
      },
      return: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/return/${data.brandId}/${data.claimCode}`, { params: data.sendData }),
        request: (data) => cafe24Api.cafe24Request.post(`/commerce/cafe24/v1/returnrequests/${data.brandId}`, { data: data.sendData })
      },
      shops: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/shops/${data.brandId}`, { params: data.sendData }),
        detail: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/shops/${data.brandId}/${data.shopNo}`, { params: data.sendData })
      },
      store: {
        list: (data) => cafe24Api.cafe24Request.get(`/commerce/cafe24/v1/store/${data.brandId}`, { params: data.sendData })
      },
      join: {
        request: () => cafe24Api.cafe24Request.post(`/commerce/join`)
      }
    };
  }
};
